import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import api from "../../api/axios";

const Header = ({ setSidebar, sidebar }) => {
  // handle clicking on profile picture state
  const [profileImageClicked, setProfileImageClicked] = useState(false);
  const [profileImage, setProfileImage] = useState(
    "/images/image.png"
  );
  const userId = localStorage.getItem("userId");

  const navigate = useNavigate();

  // show the nav when i click on profile picture
  const toggleShowNavMenu = () => {
    // set the profile to opposite state
    setProfileImageClicked(!profileImageClicked);
  };

  // toggle the sidebar on mobile devices
  const toggleSidebar = () => {
    setSidebar(!sidebar);
  };

  // fetch the profile image
  const fetchProfileImage = async () => {
    try {
      const response = await api.get("/user/profile_picture");
      if (response.data.image) {
        setProfileImage(`https://api.crosscheckconf.net${response.data.image}`);
      }
    } catch (error) {
      console.error("Error fetching profile image:", error);
    }
  };

  // handle logout
  const handleLogout = () => {
    // Clear localStorage
    localStorage.removeItem("token");
    localStorage.removeItem("role");
    // Redirect to login page
    navigate("/");
  };

  // Fetch the profile image when the component mounts
  useEffect(() => {
    fetchProfileImage();
  }, []);

  return (
    <header className="h-16 lg:h-20 flex fixed top-0 w-full left-0 z-50 bg-white shadow-lg border-b border-gray-200">
      {/* Logo Section */}
      <div className="w-24 sm:w-32 lg:w-1/6 shrink-0 bg-gradient-to-r from-blue-600 to-blue-700 h-full flex justify-center items-center">
        <Link to={"/"} className="font-bold text-white text-xl md:text-2xl hover:text-blue-100 transition-colors duration-200">
          CCP
        </Link>
      </div>
      
      {/* Main Header Content */}
      <div className="min-w-0 flex-1 bg-white h-full flex justify-between items-center px-2 sm:px-4 lg:px-6">
        {/* Mobile Menu Button */}
        <div className="flex items-center" onClick={toggleSidebar}>
          <button type="button" aria-label={sidebar ? "Fermer la navigation" : "Ouvrir la navigation"} aria-expanded={sidebar} className="lg:hidden p-2 rounded-lg text-gray-600 hover:text-gray-900 hover:bg-gray-100 transition-colors duration-200">
            <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
            </svg>
          </button>
        </div>
        
        {/* User Profile Section */}
        <div className="flex items-center relative">
          <div className="cursor-pointer" onClick={toggleShowNavMenu}>
            <div className="flex items-center space-x-3 p-2 rounded-lg hover:bg-gray-100 transition-colors duration-200">
              <img
                alt="user account"
                className="rounded-full object-cover w-8 h-8 md:w-10 md:h-10 border-2 border-gray-200"
                src={profileImage}
              />
              <span className="hidden md:block text-sm font-medium text-gray-700">
                Profile
              </span>
              <svg className="w-4 h-4 text-gray-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
              </svg>
            </div>
          </div>
          
          {/* Dropdown Menu */}
          {profileImageClicked && (
            <div className="absolute top-12 right-0 mt-2 w-56 bg-white border border-gray-200 rounded-xl shadow-lg z-50">
              <div className="py-2">
                {localStorage.getItem("role") !== "Gerant" && <>
                <Link
                  to={`/profile/${userId}`}
                  className="flex items-center px-4 py-3 text-gray-700 hover:bg-gray-50 transition-colors duration-200"
                >
                  <svg className="w-5 h-5 mr-3 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" />
                  </svg>
                  Profile
                </Link>
                <Link
                  to="/update-password"
                  className="flex items-center px-4 py-3 text-gray-700 hover:bg-gray-50 transition-colors duration-200"
                >
                  <svg className="w-5 h-5 mr-3 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 7a2 2 0 012 2m4 0a6 6 0 01-7.743 5.743L11 17H9v2H7v2H4a1 1 0 01-1-1v-2.586a1 1 0 01.293-.707l5.964-5.964A6 6 0 1121 9z" />
                  </svg>
                  Update Password
                </Link>
                </>}
                <div className="border-t border-gray-100 my-1"></div>
                <button
                  onClick={handleLogout}
                  className="flex items-center w-full px-4 py-3 text-red-600 hover:bg-red-50 transition-colors duration-200"
                >
                  <svg className="w-5 h-5 mr-3" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 16l4-4m0 0l-4-4m4 4H7m6 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h4a3 3 0 013 3v1" />
                  </svg>
                  Logout
                </button>
              </div>
            </div>
          )}
        </div>
      </div>
    </header>
  );
};

export default Header;
